import React, { type FC, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { unPublishHelper } from 'reactApp/appHelpers/publishHelper';
import { renderUnpublishWeblinkDialog } from 'reactApp/components/SharingWindow/blocks/Weblink/SharingWeblink.helpers';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';
import { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import { XrayItemType } from 'reactApp/modules/home/home.types';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { getACL } from 'reactApp/modules/weblinkAccessControl/weblinkAccessControl.selectors';
import { Button, ButtonSizeMode, ButtonVariant } from 'reactApp/ui/Button/Button';
import { sendGa } from 'reactApp/utils/ga';

import { SharingNewWeblinkList } from '../WeblinkList/SharingNewWeblinkList';
import styles from './SharingNewCollapsedDialog.css';

interface CollapsedContentProps {
    isPhone?: boolean;
    isReadOnly: boolean;
    item?: PublishItem;
}

export const SharingNewCollapsedContent: FC<CollapsedContentProps> = ({ isPhone, item, isReadOnly }) => {
    const itemStorage = useSelector(getCurrentStorage);
    const storage = item?.storage || itemStorage;
    const acList = useSelector(getACL);

    const onActionClick = useCallback(() => {
        sendGa('unpublish');
        if (storage === EStorageType.attaches) {
            sendGa('attaches-unpublish');
        }

        if (!item) {
            return;
        }
        unPublishHelper({ items: [item] });
    }, [storage, item]);

    const xrayItemType = useMemo(() => {
        if (storage === EStorageType.albums) {
            return XrayItemType.album;
        } else if (item?.isFolder) {
            return XrayItemType.folder;
        }
        return XrayItemType.file;
    }, [item?.isFolder, storage]);

    const onCloseModalClick = useCallback(() => {
        closePopupHelper(popupNames.SHARING_WEBLINK_COLLAPSED_USER_LIST);
    }, []);

    const onCloseAccessClick = useCallback(() => {
        renderUnpublishWeblinkDialog({ onActionClick, variant: SHARING_VARIANT.folders });
        onCloseModalClick();
    }, [onActionClick, onCloseModalClick]);

    return (
        <>
            <h3 className={styles.heading}>У кого есть доступ</h3>
            <SharingNewWeblinkList
                item={item}
                isPhone={isPhone}
                isReadOnly={isReadOnly}
                variant={SHARING_VARIANT.folders}
                isEmbeded
                from={EFrom.WEBLINK}
                xrayItemType={xrayItemType}
            />
            <div className={styles.buttons}>
                <Button theme={'base'} middle onClick={onCloseModalClick} sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.middle}>
                    <span>Вернуться назад</span>
                </Button>
                <Button
                    disabled={acList.length === 0}
                    className={styles.closeBtn}
                    variant={ButtonVariant.flat}
                    theme={'base'}
                    middle
                    onClick={onCloseAccessClick}
                    sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.middle}
                >
                    <span>Закрыть доступ всем</span>
                </Button>
            </div>
        </>
    );
};
